import TabbedContainer, {Tab} from './TabbedContainer'

export {TabbedContainer, Tab}
export default TabbedContainer
